import { NotificationManager, PaymentV2Api } from '@atlas/core';

const MILLISECONDS_IN_SECOND = 1000;

const getTimeValues = (createTime, expirationCountdown, ttlInSeconds) => ({
  countdownMs: Number(expirationCountdown) * MILLISECONDS_IN_SECOND,
  createdAtMs: Number(createTime),
  ttlMs: Number(ttlInSeconds) * MILLISECONDS_IN_SECOND,
});

const isValidTimeValue = value => {
  const isPresent = value !== null && value !== '';

  return isPresent && Number.isFinite(Number(value));
};

export const shouldCreateNewDeposit = (createTime, expirationCountdown, ttlInSeconds) => {
  const hasValidTimeValues = [createTime, expirationCountdown, ttlInSeconds].every(
    isValidTimeValue,
  );

  if (!hasValidTimeValues) {
    return true;
  }

  const { countdownMs, createdAtMs, ttlMs } = getTimeValues(
    createTime,
    expirationCountdown,
    ttlInSeconds,
  );
  const result = Date.now() - createdAtMs + countdownMs;

  return result >= ttlMs;
};

export const generateNewPixCode = async ({
  amount,
  createTime,
  expirationCountdown,
  formId,
  id,
  interpolationValues,
  paymentMethod,
  paymentOptions,
  publicPaymentId,
}) => {
  let newData;

  if (
    shouldCreateNewDeposit(createTime, expirationCountdown, paymentMethod.transactionTtlInSeconds)
  ) {
    const response = await PaymentV2Api.createAsyncDeposit({
      ...paymentOptions,
      amount,
      pmId: String(paymentMethod.id),
    });
    newData = await PaymentV2Api.getPaymentStatus(response.publicPaymentId);
  } else {
    newData = await PaymentV2Api.getPaymentStatus(publicPaymentId);
  }

  NotificationManager.removeNotification(id);
  NotificationManager.display({
    data: {
      amount,
      createTime: newData.createTime,
      formId,
      interpolationValues: newData.formData?.additionalParams ?? interpolationValues,
      paymentMethod,
      ...(paymentOptions && { paymentOptions }),
      pixCode: newData.redirectUrl,
      publicPaymentId: newData.publicPaymentId ?? publicPaymentId,
    },
    type: 'pixDepositResult',
  });
};
